function withShallowBailout<S extends object, A>(reducer: (state: S, action: A) => S): (state: S, action: A) => S {
    return (state, action) => {
        const next = reducer(state, action);
        if (next === state) {
            return state;
        }
        const keys = Object.keys(next) as (keyof S)[];
        if (keys.length !== Object.keys(state).length) {
            return next;
        }
        return keys.every((k) => next[k] === state[k]) ? state : next;
    };
}

export { withShallowBailout };
